import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'

const CASES = ['agenticMemory', 'docHeavySaas', 'forensicResearch', 'complianceFirst'] as const

export function UseCases() {
  const { t } = useTranslation()

  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-10 md:py-12">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {CASES.map((key, i) => (
          <ScrollFade key={key} delay={i * 60}>
            <article className="h-full p-5 rounded-lg border border-mono-800/[0.16] dark:border-mono-100/[0.16] bg-gradient-to-b from-mono-800/[0.06] to-mono-800/[0.02] dark:from-mono-100/[0.06] dark:to-mono-100/[0.02]">
              <h3 className="text-2xl font-bold font-display">{t(`useCases.${key}`)}</h3>
              <p className="mt-3 text-lg opacity-80 leading-relaxed">
                {t(`lorem:useCases.${key}.detail`)}
              </p>
            </article>
          </ScrollFade>
        ))}
      </div>
    </section>
  )
}
